import {createActionGroup, emptyProps, props} from "@ngrx/store";
import {
    AlgorithmicDmvAcceptRequest,
    AlgorithmicDmvBulkAcceptOutcome,
    AlgorithmicDmvJobDetail,
    AlgorithmicDmvJobInfo,
    AlgorithmicDmvRequest
} from "../generated-sources/api";

export const AlgorithmicDmvActions = createActionGroup({
    source: "Algorithmic DMV",
    events: {
        // Start
        start: props<{ fundId: number; request: AlgorithmicDmvRequest }>(),
        startSuccess: props<{ fundId: number; taskInfoId: number }>(),
        startError: props<{ fundId: number; errorMsg: string }>(),

        // List jobs (per fund) + polling
        loadJobs: props<{ fundId: number }>(),
        loadJobsSuccess: props<{ fundId: number; jobs: AlgorithmicDmvJobInfo[] }>(),
        loadJobsError: props<{ fundId: number; errorMsg: string }>(),

        // Detail (viewer)
        loadDetail: props<{ taskInfoId: number }>(),
        loadDetailSuccess: props<{ detail: AlgorithmicDmvJobDetail }>(),
        loadDetailError: props<{ errorMsg: string }>(),

        // Accept / skip per result
        acceptResult: props<{ resultId: number; request: AlgorithmicDmvAcceptRequest; taskInfoId: number }>(),
        acceptResultSuccess: props<{ resultId: number; taskInfoId: number }>(),
        acceptResultError: props<{ resultId: number; errorMsg: string }>(),

        skipResult: props<{ resultId: number; taskInfoId: number }>(),
        skipResultSuccess: props<{ resultId: number; taskInfoId: number }>(),
        skipResultError: props<{ resultId: number; errorMsg: string }>(),

        // Bulk accept-all (US-1159 §6.5)
        acceptAllSuggestions: props<{ taskInfoId: number }>(),
        acceptAllSuggestionsSuccess: props<{ taskInfoId: number; outcome: AlgorithmicDmvBulkAcceptOutcome }>(),
        acceptAllSuggestionsError: props<{ taskInfoId: number; errorMsg: string }>(),

        clearError: emptyProps()
    }
});
